import { PLPType, PLPTypes } from "src/types/PLPType.d";

const contextKeys: { [p: number]: string } = {
  [PLPType.BRAND_PLP]: "brand_plp",
  [PLPType.ICONS_PLP]: "icons_plp",
  [PLPType.CATEGORY_PLP]: "category_plp",
  [PLPType.NEW_IN]: "new_in_plp",
  [PLPType.HOT_DEALS]: "hot_deals_plp",
  [PLPType.CLEARANCE_PLP]: "clearance_plp",
  [PLPType.DESIGNER_PLP]: "designer_plp",
  [PLPType.COLLECTIONS_PLP]: "collection_plp",
  [PLPType.SEARCH_PLP]: "search_catalog_plp",
  [PLPType.SHOP_TYPE]: "shop_type_plp",
};

export const PLPContextKeys: Record<PLPTypes, string> = {
  BRAND_PLP: "brand_plp",
  CATEGORY_PLP: "category_plp",
  NEW_IN: "new_in_plp",
  COLLECTIONS_PLP: "collection_plp",
  SEARCH_PLP: "search_catalog_plp",
  SHOP_TYPE: "shop_type_plp",
} as const;

export const listTypes: Record<PLPType, string> = {
  [PLPType.BRAND_PLP]: "brand",
  [PLPType.CATEGORY_PLP]: "category",
  [PLPType.COLLECTIONS_PLP]: "collection",
  [PLPType.SEARCH_PLP]: "search",
  [PLPType.NEW_IN]: "new_in",
  [PLPType.SHOP_TYPE]: "shop_type_plp",
} as const;

export const PLPListTypes: Record<PLPTypes, string> = {
  BRAND_PLP: "brand",
  CATEGORY_PLP: "category",
  COLLECTIONS_PLP: "collection",
  SEARCH_PLP: "search",
  NEW_IN: "new_in",
  SHOP_TYPE: "shop_type_plp",
} as const;

export type ContextKey = typeof contextKeys;

export default contextKeys;
